module.exports = __webpack_public_path__ + "static/media/docker_dotnet.90eec533.png";